import styled from '@emotion/styled';

export const ClientsTopWrapper = styled.div`
    padding: 11px 16px 16px 11px;
    display:flex;
    flex-direction: column;
    flex-grow:1;
    flex-basis: 55%;
    border-radius: 16px;
    border: 1px solid ${(props) => props.theme.colors.gray};
    position: relative;
`;
export const ClientsTopContainer = styled.div`
    position: absolute;
    display:flex;
    top: 11px;
    left: 11px;
    right: 16px;
    bottom: 16px;
`;
export const ClientsBottomWrapper = styled.div`
    padding: 16px;
    display:flex;
    flex-direction: column;
    border-radius: 16px;
    flex: 1;
    border: 1px solid ${(props) => props.theme.colors.gray};
    position: relative;
`;
export const ClientsBottomContainer = styled.div`
    position: absolute;
    display:flex;
    top: 16px;
    left: 16px;
    right: 16px;
    bottom: 16px;
`;
export const ClientsList = styled.div`
    display:flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    right: 4px;
    bottom: 0;
    flex-shrink: 0;
    overflow-y: auto;
    flex-grow: 1;
    gap: 8px;
    padding-right: 4px;
`;
export const ClientsListWrapper = styled.div`
    flex-basis: 50%;
    flex-shrink: 0;
    flex-grow: 1;
    position: relative;
`;
export const ClientsInfoWrapper = styled.div`
    display:flex;
    flex-direction: column;
    flex-basis: 50%;
    flex-shrink: 0;
    flex-grow: 1;
    padding: 5px 0 0 0;
`;
export const ClientsInfoContainer = styled.div`
    display:flex;
    flex-direction: column;
    flex: 1 0 auto;
    width: 100%;
    border-left: 1px solid ${(props) => props.theme.colors.gray};
    padding-left: 16px;
`;
export const ClientLineWrapper = styled.div`
    display:flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 12px 5px 5px;
    border-radius: 4px;
    cursor: pointer;
    &:hover {
        // .1 opacity
        background-color: ${(props) => props.theme.colors.primaryColor + '1A'};
    }
    &.active {
        // .25 opacity
        background-color: ${(props) => props.theme.colors.primaryColor + '40'};
    }
`;
export const ClientLineLeft = styled.div`
    display:flex;
    align-items: center;
    gap: 16px;
`;
export const ClientInfoSmallBox = styled.div`
    height: 63px;
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.colors.gray};
    flex: 1 0 auto;
    position: relative;
    display:flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px;
`;
export const OrdersList = styled.div`
    display:flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    right: 4px;
    bottom: 0;
    flex-shrink: 0;
    overflow-y: auto;
    flex-grow: 1;
    gap: 8px;
    padding-right: 4px;
`;
export const OrdersListWrapper = styled.div`
    flex-basis: 45%;
    flex-shrink: 0;
    flex-grow: 1;
    position: relative;
    display:flex;
    flex-direction: column;
`;
export const OrdersInfoWrapper = styled.div`
    display:flex;
    flex-direction: column;
    flex: 1 0 auto;
    flex-basis: 55%;
    border-left: 1px solid ${(props) => props.theme.colors.gray};
    padding-left: 16px;
`;
export const OrderLine = styled.div`
    border-radius: 4px;
    padding: 8px 16px;
    cursor: pointer;
    &:hover {
        // .1 opacity
        background-color: ${(props) => props.theme.colors.primaryColor + '1A'};
    }
    &.active {
        // .25 opacity
        background-color: ${(props) => props.theme.colors.primaryColor + '40'};
    }
`;
export const OrderDestinationLine = styled.div`
    flex: 1 0 auto;
    height: 1px;
    background-color: ${(props) => props.theme.colors.gray};
    position: relative;
    margin-top: 10px;
    &:before {
        content: '';
        position: absolute;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #D9D9D9;
        top: -4px;
        left: -4px;
    }
    &:after {
        content: '';
        position: absolute;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #D9D9D9;
        top: -4px;
        right: -4px;
    }
`;
export const OrderReadyLine = styled.div`
    width: 100%;
    display:flex;
    justify-content: center;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray};
`;
